<template>
    <div>
        <SelectField
            :model-value="modelValue"
            name="status"
            label="status"
            help="help_bulk_change_order_status"
            :options="mapEnumToArray(OrderStatus)"
            :reduce="reduceEnumValue"
            @update:model-value="onStatusChange"
        />
        <template v-if="modelValue === OrderStatus.CANCELED">
            <ToggleSwitch
                :model-value="withRefund"
                name="bulk_with_refund"
                label="with_refund"
                help="help_with_refund"
                @update:model-value="onWithRefundChange"
            />
            <ToggleSwitch
                v-if="withRefund"
                :model-value="confirmedRefundOnAccepted"
                name="bulk_confirmed_refund_on_accepted"
                label="confirm_refund_on_accepted_orders"
                help="help_confirm_refund_on_accepted_orders"
                @update:model-value="
                    (val) => emit('update:confirmedRefundOnAccepted', val)
                "
            />
        </template>
    </div>
    <h3>{{ $t('orders') }}</h3>
    <ul class="list-disc pl-8">
        <li
            v-for="order in orders"
            :key="(order.order_uid as string)"
        >
            {{ order.order_uid }}
        </li>
    </ul>
</template>

<script setup lang="ts">
import { useEnum } from '@composables/common'
import { SelectField, ToggleSwitch } from '@src/components'
import { OrderStatus } from '@src/enums'
import { Order } from '@src/types'

defineProps<{
    modelValue: number
    withRefund: boolean
    confirmedRefundOnAccepted: boolean
    orders: Order[]
}>()

const emit = defineEmits([
    'update:modelValue',
    'update:withRefund',
    'update:confirmedRefundOnAccepted',
])

const { mapEnumToArray, reduceEnumValue } = useEnum()

function onStatusChange(value: number) {
    emit('update:modelValue', value)
    if (value !== OrderStatus.CANCELED) {
        emit('update:withRefund', false)
        emit('update:confirmedRefundOnAccepted', false)
    }
}

function onWithRefundChange(value: boolean) {
    emit('update:withRefund', value)
    if (!value) {
        emit('update:confirmedRefundOnAccepted', false)
    }
}
</script>

<style scoped></style>
